/* @flow */

import loadable from '@loadable/component';

export default loadable(() =>
  import(
    /* webpackChunkName: "__newExpressionOfGratitude" */ './NewExpressionOfGratitude'
  ),
);
